<template>
  <div>
    <v-dialog v-model="dialog" persistent eager scrollable max-width="500px">
      <v-form ref="EvaluationReviewDialog" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>College Evaluation & Review Committee</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    outlined
                    small-chips
                    required
                    deletable-chips
                    v-model="year"
                    :rules="[formRules.required]"
                    :items="yearSelection"
                    dense
                    class="rounded-lg"
                    label="Year"
                    color="#6DB249"
                  >
                  </v-autocomplete
                ></v-col>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    outlined
                    small-chips
                    required
                    deletable-chips
                    v-model="position"
                    :rules="[formRules.required]"
                    :items="positionList"
                    item-value="id"
                    item-text="name"
                    dense
                    class="rounded-lg"
                    @change="changePosition()"
                    label="Position"
                    color="#6DB249"
                  >
                  </v-autocomplete
                ></v-col>
                <v-col cols="12" md="12" v-if="bureau == 1 && position == 3">
                  <v-autocomplete
                    outlined
                    small-chips
                    required
                    deletable-chips
                    v-model="institute"
                    :rules="[formRules.required]"
                    :items="instituteList"
                    item-value="id"
                    item-text="name"
                    dense
                    class="rounded-lg"
                    @change="changeInstitute()"
                    label="Institute"
                    color="#6DB249"
                  >
                  </v-autocomplete
                ></v-col>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    outlined
                    small-chips
                    required
                    deletable-chips
                    v-model="employee"
                    :rules="[formRules.required]"
                    :items="formatEmployeeNameList"
                    item-value="usID"
                    item-text="name"
                    dense
                    class="rounded-lg"
                    label="Employee"
                    color="#6DB249"
                  >
                  </v-autocomplete
                ></v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              color="#519043"
              class="white--text"
              v-if="action == 'Add'"
              @click="addEvaluationReview()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Add
            </v-btn>
            <v-btn
              color="#519043"
              class="white--text"
              v-if="action == 'Update'"
              @click="updateEvaluationReview()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: null,
    action: null,
    tab: null,
    bureau: null,
  },
  data() {
    return {
      dialog: false,
      positionList: [
        { id: 1, name: "Chairperson" },
        { id: 2, name: "Vice-Chairperson" },
        { id: 3, name: "Member" },
      ],
      instituteList: [],
      institute: null,
      position: 3,
      employeeList: [],
      employee: null,
      yearSelection: [],
      year: null,

      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },

  computed: {
    formatEmployeeNameList() {
      let toReturn = this.employeeList;
      let newData = [];
      if (this.bureau == 2) {
        for (let i = 0; i < toReturn.length; i++) {
          toReturn[i].name = this.toTitleCase(toReturn[i].name);
        }
        return toReturn;
      } else {
        if (this.position == 3) {
          if (this.institute == 1) {
            for (let i = 0; i < toReturn.length; i++) {
              if (toReturn[i].officeID == 62) {
                newData.push(toReturn[i]);
              }
            }
          } else if (this.institute == 2) {
            for (let i = 0; i < toReturn.length; i++) {
              if (toReturn[i].officeID == 63) {
                newData.push(toReturn[i]);
              }
            }
          } else if (this.institute == 3) {
            for (let i = 0; i < toReturn.length; i++) {
              if (toReturn[i].officeID == 64) {
                newData.push(toReturn[i]);
              }
            }
          } else if (this.institute == 4) {
            for (let i = 0; i < toReturn.length; i++) {
              if (toReturn[i].officeID == 61) {
                newData.push(toReturn[i]);
              }
            }
          } else if (this.institute == 5) {
            for (let i = 0; i < toReturn.length; i++) {
              if (toReturn[i].office == 71) {
                newData.push(toReturn[i]);
              }
            }
          }
          for (let i = 0; i < newData.length; i++) {
            newData[i].name = this.toTitleCase(newData[i].name);
          }
          return newData;
        } else {
          for (let i = 0; i < toReturn.length; i++) {
            toReturn[i].name = this.toTitleCase(toReturn[i].name);
          }
          return toReturn;
        }
      }
    },
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        if (data.id) {
          this.year = data.year;
          this.position = data.position;
          this.employee = data.user_detailID.toString();
          (this.institute = data.institute), this.initialize();
        } else {
          //   this.$refs.EvaluationReviewDialog.reset();
          this.institute = null;
          this.employee = null;
          this.initialize();
        }
      },
      deep: true,
    },
  },

  methods: {
    initialize() {
      this.getEmpDetails();
      this.loadYearSelection();
      this.getInstitutes();
    },

    getEmpDetails() {
      this.axiosCall(
        "/user-details/getUsersHeadProgChairAbove_Office",
        "GET"
      ).then((res) => {
        this.employeeList = res.data;
        // console.log(res.data);
      });
    },
    getInstitutes() {
      this.axiosCall("/institutes", "GET").then((res) => {
        this.instituteList = res.data;
      });
    },

    loadYearSelection() {
      let d = new Date();
      this.yearSelection = [];
      const currentYear = d.getFullYear();
      const nextYear = currentYear + 1;
      this.year = currentYear;
      this.yearSelection.push(currentYear, nextYear);
    },
    addEvaluationReview() {
      if (this.$refs.EvaluationReviewDialog.validate()) {
        let data = {
          position: this.position,
          user_detailID: this.employee,
          institute: this.position == 3 ? this.institute : null,
          year: this.year,
          composition: this.tab,
          bureau: this.bureau,
        };
        console.log(data);
        this.axiosCall("/evaluation-review-committee", "POST", data).then(
          (res) => {
            if (res.data.status == 201) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else if (res.data.status == 400) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          }
        );
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Please input required field";
      }
    },
    updateEvaluationReview() {
      let data = {
        position: this.position,
        user_detailID: this.employee,
        institute: this.position == 3 ? this.institute : null,
        year: this.year,
        composition: this.tab,
        bureau: this.bureau,
      };
      console.log(data, this.data.id);
      this.axiosCall(
        "/evaluation-review-committee/" + this.data.id,
        "PATCH",
        data
      ).then((res) => {
        if (res.data.status == 201) {
          this.closeD();
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Successfully updated job posting!";

          // location.reload();
        } else if (res.data.status == 400) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },
    changePosition() {
      this.getEmpDetails();
    },
    changeInstitute() {
      this.getEmpDetails();
    },
    closeD() {
      this.eventHub.$emit("closeEvaluationReviewDialog", false);
      this.dialog = false;
    },
  },
};
</script>
